import "./sass/layout.scss";

// COMMON
import '../modules/component/common/module.js';

// EIOVISUAL MODULES
import '../modules/eiovisual/cover/module.js';
import '../modules/eiovisual/cover2/module.js';
import '../modules/eiovisual/cover3/module.js';
import '../modules/eiovisual/search1/module.js';
import '../modules/eiovisual/previews1/module.js';
import '../modules/eiovisual/previews2/module.js';
import '../modules/eiovisual/slider1/module.js';
import '../modules/eiovisual/magazine1/module.js';
import '../modules/eiovisual/cf7newsletter1/module.js';
import '../modules/eiovisual/titolo1/module.js';
import '../modules/eiovisual/titolo2/module.js';
import '../modules/eiovisual/titolo3/module.js';
import '../modules/eiovisual/testo1/module.js';
import '../modules/eiovisual/testo2/module.js';
import '../modules/eiovisual/testo3/module.js';
import '../modules/eiovisual/risorse/module.js';
import '../modules/eiovisual/evidenza1/module.js';
import '../modules/eiovisual/image100/module.js';
import '../modules/eiovisual/collapse1/module.js';
import '../modules/eiovisual/jobs/module.js';

import '../modules/eiovisual/wpgallery/module.js';

// require('offline-plugin/runtime').install();

// missing forEach on NodeList for IE11
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}